var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{style:({
    backgroundColor: _vm.bgcolor,
    height: _vm.height + 'px',
    width: _vm.width,
    margin: _vm.margin,
    padding: _vm.padding
  }),attrs:{"disabled":""}},[_c('div',{staticClass:"spinner"},[_c('div',{staticClass:"bounce1",style:({ backgroundColor: _vm.color })}),_c('div',{staticClass:"bounce2",style:({ backgroundColor: _vm.color })}),_c('div',{staticClass:"bounce3",style:({ backgroundColor: _vm.color })})])])}
var staticRenderFns = []

export { render, staticRenderFns }